// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"buildControls_BuildControls__2nFEV","OrderButton":"buildControls_OrderButton__3PjNj"};